// extracted by mini-css-extract-plugin
export default {"modalRoot":"partners-notifier_modalRoot__vn874","modalFooter":"partners-notifier_modalFooter__WDum8","footerButton":"partners-notifier_footerButton__VIqy8"};